import React, { useEffect, useState } from 'react';
import { api, errText } from '@/lib/api';
import { Card } from '@/components/ui/card';

export default function AdminAudit() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');
  useEffect(() => {
    api.get('/admin/audit-logs').then(r => setItems(r.data || [])).catch((e) => setError(
      e?.response?.status === 403
        ? "You don't have audit-log access. Ask a practice admin to turn on \"View audit logs\" for you."
        : errText(e, 'Could not load audit logs')));
  }, []);
  return (
    <div className="p-4 lg:p-6 max-w-7xl mx-auto">
      <h1 className="text-base lg:text-lg font-semibold tracking-tight mb-4">Audit Logs</h1>
      <Card>
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="audit-log-table">
            <thead className="bg-card border-b"><tr className="text-left text-xs text-muted-foreground">
              <th className="px-3 py-2">Timestamp</th><th className="px-3 py-2">Actor</th><th className="px-3 py-2">Role</th><th className="px-3 py-2">Action</th><th className="px-3 py-2">Target</th><th className="px-3 py-2">Details</th>
            </tr></thead>
            <tbody>
              {items.map(a => (
                <tr key={a.id} className="border-b" data-testid={`audit-row-${a.id}`}>
                  <td className="px-3 py-2 text-muted-foreground">{(a.timestamp || '').slice(0, 19).replace('T', ' ')}</td>
                  <td className="px-3 py-2">{a.actor_name}</td>
                  <td className="px-3 py-2 capitalize">{a.actor_role}</td>
                  <td className="px-3 py-2 font-mono text-xs">{a.action}</td>
                  <td className="px-3 py-2 text-xs">{a.target_type}{a.target_id ? `: ${a.target_id.slice(0, 8)}…` : ''}</td>
                  <td className="px-3 py-2 text-xs text-muted-foreground max-w-md truncate">{a.details ? JSON.stringify(a.details) : ''}</td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={6} className="px-6 py-12 text-center text-muted-foreground" data-testid="audit-log-empty">{error || 'No audit entries yet.'}</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
